/**
 * External Dependencies
 */
var Flickity = require( 'flickity-fade' );

const Slider = {
	init: () => {
		Slider.flickity();
	},
	flickity: () => {
		const sliderBlocks = document.querySelectorAll('.carousel');

		sliderBlocks.forEach( ( sliderBlock ) => {
			let slider = sliderBlock;

			if( sliderBlock.classList.contains( 'wp-block-gallery' ) ) {
				slider = sliderBlock.children[0];
			}
			const attrs = JSON.parse( sliderBlock.dataset.attributes );

			const flkty = new Flickity( slider, {
				// options
				contain: true,
				...attrs
			});
		} );
	}
}

Slider.init();
